import { CardWithBorder } from 'src/components/CardWithBorder';
import { SelectBox } from 'src/components/SelectBox';
import { timezoneOptions } from './constants';
import { useContactWindow } from './ContactWindowContext';

export const TimezoneSettings = () => {
  const { primaryTz, fallbackTz, setPrimaryTz, setFallbackTz } =
    useContactWindow();
  return (
    <CardWithBorder>
      <h3 className="mb-2">Timezone</h3>
      <p className="text-sm text-neutral-500 mb-4">
        Determine which timezone to use when scheduling outreach
      </p>
      <div className="flex flex-col gap-4">
        <div className="sm:w-1/2">
          <label className="block text-sm font-medium text-neutral-700 mb-2">
            Primary
          </label>
          <SelectBox
            options={timezoneOptions}
            value={primaryTz}
            onChange={(v) => {
              const option = timezoneOptions.find((o) => o.value === v);
              if (option) setPrimaryTz(option);
            }}
          />
        </div>
        {primaryTz?.value === 'contact-local' && (
          <div className="sm:w-1/2">
            <label className="block text-sm font-medium text-neutral-700 mb-2">
              Fallback
            </label>
            <SelectBox
              options={timezoneOptions.filter(
                (o) => o.value !== 'contact-local',
              )}
              value={fallbackTz}
              onChange={(v) => {
                const option = timezoneOptions.find((o) => o.value === v);
                if (option) setFallbackTz(option);
              }}
            />
          </div>
        )}
      </div>
    </CardWithBorder>
  );
};

export default TimezoneSettings;
